/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extra_Session_Hint_MonthInputs */

const fr_extra_session_hint_month = /** @type {(inputs: Extra_Session_Hint_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si tu te désinscris, le cours est gardé en réserve et utilisé plus tard, une fois ton crédit du mois atteint.`)
};

/**

* @param {Extra_Session_Hint_MonthInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const extra_session_hint_month = /** @type {((inputs?: Extra_Session_Hint_MonthInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extra_Session_Hint_MonthInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_extra_session_hint_month(inputs)
});